import { render, staticRenderFns } from "./ModalPrimeiraEtapaListagem.vue?vue&type=template&id=33c4830e&scoped=true"
import script from "./ModalPrimeiraEtapaListagem.vue?vue&type=script&lang=js"
export * from "./ModalPrimeiraEtapaListagem.vue?vue&type=script&lang=js"
import style0 from "./ModalPrimeiraEtapaListagem.vue?vue&type=style&index=0&id=33c4830e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c4830e",
  null
  
)

export default component.exports